import React, { RefObject, useState } from "react";
import { ZoomIn, ZoomOut, Layers, Sliders, EyeOff, Undo2, Redo2, Save, Palette, Type, Bold, Paintbrush, AlignCenter, TextCursor, AlignLeft, AlignRight, icons, Check, Eye, DropletIcon, ArrowLeft, Droplet, ChevronLeft, CheckIcon, Pencil, PencilOff, BoldIcon, LightbulbIcon, ItalicIcon, Text, TypeIcon, CaseLowerIcon, CaseUpperIcon, CaseSensitiveIcon, Sparkle, SparkleIcon, Sparkles, Loader2 } from 'lucide-react';
import { Dropdown, DropdownMultiMenu } from "../../../components"
import { Button } from "../../../features/swimLane";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../contexts/ThemeContext";
import { useBranding } from "../../../contexts/BrandingContext";
import { Block } from '../../lib/types';
import { ColorPicker } from '../ColorPicker';
import { Routes } from "../../../routes";
import { iUser } from "../../../components/type";
import { FamlaServices } from "../../../services";
import { useAppSelector } from "../../../stores";
import { Images } from "../../../constants";
import { slice } from "../../../utils";
import { getBrandingColor } from "../../../utils/brandingStyles";
import { ApprovalModal } from "../../../views/modal";
import ActiveUsersBar from './ActiveUsersBar';
import { ActiveUser, SaveStatus } from '../../hooks/useCollaboration';
import { trackUiButtonEventAsync, UI_BUTTON_EVENTS } from '../../../services/api/uiButtonStatsService';


interface TopBarProps {
    isEditing: boolean;
    hasUnsavedChanges: boolean;
    scale: number;
    approvallist: iUser[];
    processId: string;
    activeFocusdisa: () => void;
    activeFocusa: () => void;
    handleZoom: (direction: "in" | "out") => void;
    handleExportPdf: () => void | Promise<void>;
    handleExportPng: () => void | Promise<void>;
    isExporting?: boolean;
    exportFile: (type: string) => void;
    swimlaneRef: RefObject<{ toggleEditMode: () => void }>;
    role: string;
    canEditMap: boolean;
    handleToggleLayers: () => void;
    handleToggleLayersLine: () => void;
    showLayers: boolean;
    showLayersLine: boolean;
    showWarnings: boolean;
    showNotes: boolean;
    onToggleNotes: () => void;
    /** True while stakeholder data for warning badges is still being fetched (POST /reference/). */
    warningsStakeholderLoading?: boolean;
    onToggleWarnings: () => void;
    onUndo: () => void;
    onRedo: () => void;
    selectedBlock: Block | null;
    currentData: any;
    handleWidthChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleBlockUpdate: (updates: Partial<Block>) => void;
    handleTextStyleUpdate: (property: string, value: any) => void;
    canUndo: boolean;
    canRedo: boolean;
    setMarginTop: React.Dispatch<React.SetStateAction<string>>;
    handleSelectAll: () => void;
    onToggleBlocksContentFit: () => void;
    isBlocksContentFitActive: boolean;
    title: string;
    handleCopy: () => void;
    handleCut: () => void;
    handlePaste: () => void;
    allSwimLane: any[];
    setMap: React.Dispatch<React.SetStateAction<string>>;
    owner: iUser;
    /** Porteur processus ou co-propriétaire (accès menu Propriétaire en cartographie) */
    isProcessMapManager: boolean;
    collaborators: any[];
    setShowRightPanel: React.Dispatch<React.SetStateAction<boolean>>;
    showRightPanel: boolean;
    onMakeCopy: () => void;
    onRenameCurrentMap: () => void;
    // Collaboration temps réel
    activeUsers?: ActiveUser[];
    currentUserId?: string;
    saveStatus?: SaveStatus;
    isWsConnected?: boolean;
}

type StateType = "shape" | "properties" | "hide";

const TopBar: React.FC<TopBarProps> = ({
    isEditing,
    hasUnsavedChanges,
    scale,
    approvallist,
    processId,
    activeFocusdisa,
    activeFocusa,
    handleZoom,
    handleExportPdf,
    handleExportPng,
    isExporting = false,
    exportFile,
    swimlaneRef,
    role,
    canEditMap,
    handleToggleLayers,
    handleToggleLayersLine,
    showLayers,
    showLayersLine,
    showWarnings,
    showNotes,
    onToggleNotes,
    warningsStakeholderLoading = false,
    onToggleWarnings,
    onUndo,
    onRedo,
    selectedBlock,
    currentData,
    handleWidthChange,
    handleBlockUpdate,
    handleTextStyleUpdate,
    canUndo,
    canRedo,
    setMarginTop,
    handleSelectAll,
    onToggleBlocksContentFit,
    isBlocksContentFitActive,
    title,
    handleCopy,
    handleCut,
    handlePaste,
    allSwimLane,
    setMap,
    owner,
    isProcessMapManager,
    collaborators,
    setShowRightPanel,
    showRightPanel,
    onMakeCopy,
    onRenameCurrentMap,
    activeUsers = [],
    currentUserId = '',
    saveStatus = 'idle',
    isWsConnected = false,
}) => {
    const activeSaveModal = React.useRef<HTMLDivElement>(null)
    const activeSaveModal1 = React.useRef<HTMLDivElement>(null)
    const users = useAppSelector((state) => state.auth);
    const { t } = useTranslation()
    const navigate = useNavigate()
    const mapId = useAppSelector((state) => state.mapId.mapId);
    const { theme } = useTheme();
    const { getLogo, isCustomBranding, branding } = useBranding();
    const displayLogo = getLogo(theme) || Images.logov1;
    const topbarStyle: React.CSSProperties = {};
    const handleGoBack = async () => {
        await trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.topbarOpenInterview);
        if (hasUnsavedChanges) {
            activeSaveModal.current && activeSaveModal.current.click()
        } else {
            navigate(-1);
        }

    };
    const handleGoToHome = async () => {
        await trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.topbarCloseHome);
        // if (hasUnsavedChanges) {
        //     activeSaveModal1.current && activeSaveModal1.current.click()
        // } else {
        //     navigate(Routes.HOMEVIEW);
        // }
        navigate(Routes.HOMEVIEW);
    };
    const [isPropertiesPanelOpen, setIsPropertiesPanelOpen] = useState<boolean>(true);

    const togglePropertiesPanel = () => {
        setIsPropertiesPanelOpen((prev) => {
            const newState = !prev;
            setMarginTop(newState ? '89px' : '0px');
            return newState;
        });
        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.viewPropertiesPanel);
    };


    const getClassName = (panel: boolean, color: string) => `
        p-2 rounded flex items-center gap-2 transition-colors
        ${panel
            ? `bg-${color}-200 text-${color}-700`
            : `bg-${color}-50 text-${color}-600 hover:bg-${color}-100`
        }
    `;

    const visibilityIcon = (visible: boolean) =>
        visible ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />;

    const downloadTranscript = async () => {
        await trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.fileExportTranscript);
        try {
            const response = await FamlaServices("api_host", `/file/export-pdf/?process_id=${processId}`, "GET", "", users.access_token);

            if (response.status !== 200) {
                throw new Error(`Erreur: ${response.status}`);
            }

            // Vérifier si la réponse contient un fichier PDF
            if (response.contentType && response.contentType.includes("application/pdf")) {
                const blob = response.body;
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `process_${processId}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
            }
        } catch (error) {
        }
    };

    const downloadLayerToXLS = async () => {
        await trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.fileExportAttributesXls);
        try {
            const response = await FamlaServices("api_host", `/mapping/export/layers/${mapId}`, "POST", "", users.access_token);

            if (response.status !== 200) {
                throw new Error(`Erreur: ${response.status}`);
            }

            if ("contentType" in response && response.contentType?.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
                const blob = new Blob([response.body], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `Atributes.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
            }
        } catch (error) {
        }
    };

    const menuItemsFile = [
        { label: t('features.swimlane.openInterview'), onClick: handleGoBack },
        {
            label: t('features.swimlane.makeCopy'),
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.fileMakeCopy);
                onMakeCopy();
            },
        },
        {
            label: t('features.swimlane.Renamesheet'),
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.fileRename);
                onRenameCurrentMap();
            },
            dataBsTarget: "#renameSwimlane",
            dataBsToggle: "modal",
        },
        {
            label: t('words.export'),
            children: [
                {
                    label: t('words.map'),
                    children: [
                        {
                            label: "PDF",
                            className: "dropdown-item",
                            disabled: isExporting,
                            onClick: async () => {
                                if (isExporting) return;
                                await trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.topbarExportPdf);
                                await handleExportPdf();
                            },
                        },
                        {
                            label: "PNG",
                            disabled: isExporting,
                            onClick: async () => {
                                if (isExporting) return;
                                await trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.topbarExportPng);
                                await handleExportPng();
                            },
                        },
                        {
                            label: "CSV",
                            onClick: () => {
                                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.fileExportCsv);
                                exportFile?.('csv');
                            },
                        },
                        {
                            label: "XES",
                            onClick: () => {
                                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.fileExportXes);
                                exportFile?.('xes');
                            },
                        },
                    ],
                    icons: <i className="bi bi-caret-right-fill text-secondary small"></i>
                },
                {
                    label: t('words.interview'),
                    children: [
                        { label: "Transcript", onClick: downloadTranscript }
                    ],
                    icons: <i className="bi bi-caret-right-fill text-secondary small"></i>
                },
                {
                    label: t('words.attributes'),
                    children: [
                        { label: "XLS", onClick: downloadLayerToXLS }
                    ],
                    icons: <i className="bi bi-caret-right-fill text-secondary small"></i>
                }
            ],
            icons: <i className="bi bi-caret-right-fill text-secondary small"></i>
        },

        {
            label: isEditing ? t('words.saveAs') : "",
            className: `${hasUnsavedChanges
                ? "text-black hover:text-green-500"
                : "text-black text-green-500 "
                }`
            ,
            // disabled: (!hasUnsavedChanges),
            dataBsTarget: "#renameSwimlane",
            dataBsToggle: "modal"

        },
        // {
        //     label: t("features.swimlane.enableEditMode"),
        //     className: `${hasUnsavedChanges
        //         ? "text-black hover:text-green-500"
        //         : "text-black text-gray-500 cursor-not-allowed"
        //         }`
        //     ,
        //     onClick: () => swimlaneRef.current?.toggleEditMode(),
        //     icon: isEditing ? <CheckIcon className="w-4 h-4" /> : <PencilOff className="w-4 h-4" />

        // },

        // {
        //     label: t("features.swimlane.versionHistory"),
        //     dataBsTarget: "#mapModal",
        //     dataBsToggle: "modal"
        // },
        {
            label: t("features.swimlane.versionHistory"),
            children: allSwimLane.map((swimLane) => ({
                label: slice(swimLane.name ? swimLane.name : swimLane._id, 25),
                className: "dropdown-item",
                onClick: () => {
                    void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.fileVersionSwitch);
                    setMap(swimLane._id);
                },
            })),
            classParentChildren: "overflow-scroll",
            heightCh: 250,
            icons: <i className="bi bi-caret-right-fill text-secondary small"></i>
        },

        {
            label: approvallist.length === 0 ? "" : t("words.approve"),
            dataBsTarget: `#generic${processId}`,
            dataBsToggle: "modal",
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.fileApproveOpen);
                activeFocusa();
            }
        },

        {
            label: approvallist.length === 0 ? "" : t("words.disApprove"),
            dataBsTarget: `#disapprove`,
            dataBsToggle: "modal",
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.fileDisapproveOpen);
                activeFocusdisa();
            }
        },

        // {
        //     label: t("words.improve"),
        //     dataBsTarget: `#approve`,
        //     dataBsToggle: "modal"
        // },
        {
            label: t('words.share'),
            dataBsTarget: `#shareModal${mapId}`,
            dataBsToggle: "modal",
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.fileShareOpen);
            }
        },

        { label: t('words.close'), onClick: handleGoToHome },

    ];

    const menuItemsEdit = [
        {
            label: t("features.swimlane.undo"),
            shortcut: 'Ctrl+Z',
            icon: <Undo2 className="w-4 h-4" />,
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.editUndo);
                onUndo();
            },
            disabled: !canUndo,
            className: `p-2 rounded flex items-center gap-2 ${canUndo
                ? 'text-blue-50 text-blue-600 hover:bg-blue-100'
                : 'text-gray-100 text-gray-400 cursor-not-allowed disabled'
                }`

        },


        {
            label: t("features.swimlane.redo"),
            shortcut: 'Ctrl+Y',
            icon: <Redo2 className="w-4 h-4" />,
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.editRedo);
                onRedo();
            },
            disabled: !canRedo,
            className: `p-2 rounded flex items-center gap-2 ${canRedo
                ? 'text-blue-50 text-blue-600 hover:bg-blue-100'
                : 'text-gray-100 text-gray-400 cursor-not-allowed disabled'
                }`
        },

        {
            label: t("words.copy"),
            shortcut: 'Ctrl+C',
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.editCopy);
                handleCopy();
            },
        },

        {
            label: t("words.past"),
            shortcut: 'Ctrl+V',
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.editPaste);
                handlePaste();
            },
        },

        {
            label: t("features.swimlane.selectAll"),
            shortcut: '(Ctrl+A)',
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.editSelectAll);
                handleSelectAll();
            },
        },

        {
            label: isBlocksContentFitActive
                ? t("features.swimlane.resetBlocksContentFit")
                : t("features.swimlane.fitBlocksToContent"),
            onClick: onToggleBlocksContentFit,
            disabled: !isEditing,
            className: `p-2 rounded flex items-center gap-2 ${isEditing
                ? isBlocksContentFitActive
                    ? 'bg-green-100 text-green-700 hover:bg-green-200'
                    : 'text-blue-600 hover:bg-blue-100'
                : 'text-gray-400 cursor-not-allowed disabled'
                }`,
        },
    ];
    const menuItemsView = [
        {
            label: t('words.attributes'),
            children: [
                {
                    label: isEditing ? t("features.swimlane.tasksAttributes") : '',
                    onClick: () => {
                        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.viewLayersBlocks);
                        handleToggleLayers();
                    },
                    className: `p-2 rounded flex items-center gap-2 transition-colors ${showLayers
                        ? 'bg-green-100 text-green-600 hover:bg-green-200'
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                        }`,

                    icon: visibilityIcon(showLayers)

                },
                {
                    label: isEditing ? t("features.swimlane.arrowsAttributes") : '',
                    onClick: () => {
                        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.viewLayersArrows);
                        handleToggleLayersLine();
                    },
                    className: `p-2 rounded flex items-center gap-2 transition-colors ${showLayersLine
                        ? 'bg-green-100 text-green-600 hover:bg-green-200'
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                        }`,

                    icon: visibilityIcon(showLayersLine)

                },
            ],
            icons: <i className="bi bi-caret-right-fill text-secondary small"></i>
        },
        {
            label: t('features.swimlane.warnings') || 'Warnings',
            className: getClassName(showWarnings, "purple"),
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.viewWarnings);
                onToggleWarnings();
            },
            icon: visibilityIcon(showWarnings)
        },
        {
            label: t('words.note'),
            className: getClassName(showNotes, "yellow"),
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.viewNotes);
                onToggleNotes();
            },
            icon: visibilityIcon(showNotes)
        },

        // {
        //     label: isEditing ? t("features.swimlane.shapes") : "",
        //     className: getClassName("shape", "blue"),
        //     onClick: () => togglePanel("shape"),
        //     icon: activePanel === "shape" && <Check className="w-4 h-4" />
        // },
        {
            label: isEditing ? t("features.swimlane.properties") : "",
            className: getClassName(isPropertiesPanelOpen, "purple"),
            onClick: () => togglePropertiesPanel(),
            icon: visibilityIcon(isPropertiesPanelOpen)
        },

        // {
        //     label: isEditing ? t("features.swimlane.hideElements") : '',
        //     className: "p-2 rounded flex items-center gap-2 transition-colors bg-gray-50 text-gray-600 hover:bg-gray-100",
        //     onClick: () => handlesHowProperties("hide"),
        //     icon: showProperties === "hide" ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />
        // },

        {
            label: " Zoom",
            onClick: async () => {
                await trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.topbarZoomOut);
                handleZoom("out");
            },
            className: `rounded hover:bg-gray-100 ${scale <= 0.5 && "disabled"}`,
            disabled: scale <= 0.5,
            icon: <ZoomOut className="w-4 h-4 text-gray-600" />,
            shortcut: ""
        },
        {
            label: " Zoom",
            onClick: async () => {
                await trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.topbarZoomIn);
                handleZoom("in");
            },
            className: `rounded hover:bg-gray-100 ${scale >= 2 && "disabled"}`,
            disabled: scale >= 2,
            icon: <ZoomIn className="w-4 h-4 text-gray-600" />,
            shortcut: ""
        },
    ];
    const menuItemsHelp = [
        {
            label: t('features.swimlane.reportAbug'),
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.helpReportBug);
                navigate(Routes.CONTACTUS);
            }
        }
    ];
    const menuItemsProcessOwner = [
        {
            label: t('words.attributes'),
            dataBsTarget: `#layerSettingsModal`,
            dataBsToggle: "modal",
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.ownerLayerSettings);
            }
        },
        {
            label: t('words.requestApproval'),
            dataBsTarget: `#approval${mapId}`,
            dataBsToggle: "modal",
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.ownerRequestApproval);
            }
        },
        {
            label: collaborators.length > 0 ? t('features.swimlane.enableMapEdit') : "",
            dataBsTarget: `#collaboratorModalEdit`,
            dataBsToggle: "modal",
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.ownerEnableMapEdit);
            }
        },
        {
            label: t('features.swimlane.enableDataEdit'),
            dataBsTarget: `#attributeModal`,
            dataBsToggle: "modal",
            onClick: () => {
                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.ownerEnableDataEdit);
            }
        },
        // { label: t('features.swimlane.enableDataEdit'), href: "#" },
        // { label: t('features.swimlane.moveToBin'), href: "#" },
    ];
    const menuItemsFormat = [
        {
            label: t('words.alignment'),
            icon: <AlignRight className="w-4 h-4" />,
            className: "dropdown-item",
            children: [
                {
                    label: t('words.left'),
                    icon: <AlignLeft className="w-4 h-4" />,
                    className: "dropdown-item",
                    onClick: () => {
                        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.formatTextAlignLeft);
                        handleTextStyleUpdate('textAlign', 'left');
                    }
                },
                {
                    label: t('words.center'),
                    icon: <AlignCenter className="w-4 h-4" />,
                    className: "dropdown-item",
                    onClick: () => {
                        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.formatTextAlignCenter);
                        handleTextStyleUpdate('textAlign', 'center');
                    }
                },
                {
                    label: t('words.right'),
                    icon: <AlignRight className="w-4 h-4" />,
                    className: "dropdown-item",
                    onClick: () => {
                        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.formatTextAlignRight);
                        handleTextStyleUpdate('textAlign', 'right');
                    }
                },


            ],
            icons: <i className="bi bi-caret-right-fill text-secondary small"></i>
        },

        {
            label: t('words.text'),
            icon: <BoldIcon className="w-4 h-4" />,
            className: "dropdown-item",
            children: [
                {
                    label: t('words.bold'),
                    icon: <BoldIcon className="w-4 h-4" />,
                    className: "dropdown-item",
                    onClick: () => {
                        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.formatFontBold);
                        handleTextStyleUpdate('fontWeight', 'bold');
                    }
                },
                {
                    label: t('words.italic'),
                    icon: <ItalicIcon className="w-4 h-4" />,
                    className: "dropdown-item",
                    onClick: () => {
                        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.formatFontLight);
                        handleTextStyleUpdate('fontWeight', 'light');
                    }
                },
                // {
                //     label: t('words.normal'),
                //     icon: <Text className="w-4 h-4" />,
                //     className: "dropdown-item",
                //     onClick: () => handleTextStyleUpdate('fontWeight', 'normal')
                // },


            ],
            icons: <i className="bi bi-caret-right-fill text-secondary small"></i>
        },
        {
            label: t('features.swimlane.fontSize'),
            icon: <TypeIcon className="w-4 h-4" />,
            className: "",
            children: [
                {
                    label: t('words.normal'),
                    icon: <BoldIcon className="w-4 h-4" />,
                    className: "",
                    onClick: () => {
                        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.formatTransformNone);
                        handleTextStyleUpdate('textTransform', 'none');
                    }
                },
                {
                    label: t('words.uppercase'),
                    icon: <CaseUpperIcon className="w-4 h-4" />,
                    className: "",
                    onClick: () => {
                        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.formatTransformUpper);
                        handleTextStyleUpdate('textTransform', 'uppercase');
                    }
                },
                {
                    label: t('words.lowercase'),
                    icon: <CaseLowerIcon className="w-4 h-4" />,
                    className: "",
                    onClick: () => {
                        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.formatTransformLower);
                        handleTextStyleUpdate('textTransform', 'lowercase');
                    }
                },
                {
                    label: t('words.capitalize'),
                    icon: <CaseSensitiveIcon className="w-4 h-4" />,
                    className: "",
                    onClick: () => {
                        void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.formatTransformCapitalize);
                        handleTextStyleUpdate('textTransform', 'capitalize');
                    }
                },


            ],
            icons: <i className="bi bi-caret-right-fill text-secondary small"></i>
        },

    ];
    const menuItems = [
        { label: "Action", href: "#" },
        { label: "Another action", href: "#" },
        {
            label: "Export",
            className: "dropdown-item",
            children: [
                {
                    label: "Map",
                    children: [
                        { label: "PDF", className: "dropdown-item", onClick: () => { } },
                        { label: "PNG", href: "#" },
                        { label: "CSV", href: "#" },
                        { label: "XES", href: "#" }
                    ]
                },
                {
                    label: "Interview",
                    children: [
                        { label: "Transcript", href: "#" }
                    ]
                }
            ]
        },
        { label: "Something else here", href: "#" }
    ];

    return (
        <>

            <div
                className={`fixed top-0 mapping-topbar shadow-sm transition-all duration-300 w-full`}
                style={{
                    left: isEditing ? "0" : "0",
                    right: isEditing ? "0" : "0",
                    zIndex: "1050",
                    ...topbarStyle,
                }}
            >
                <div className={`flex flex-nowrap items-start w-100 gap-3 px-4 `}>
                    <div className="flex items-center gap-3 flex-1 min-w-0 min-h-0">
                        <div className="pb-2 flex items-center">
                            <img className="img-fluid rounded-1" src={displayLogo} alt={isCustomBranding ? branding.appName : 'Famla'} style={{ height: 30, width: 'auto', objectFit: 'contain' }} />
                        </div>

                        <div data-tutorial="flowchart-info">
                            <div className="p-0 m-0 fs-5">{title}</div>
                            <div className="max-w-full flex items-center justify-between pt-0">

                                <div className="flex items-center gap-3" data-tutorial="flowchart-topbar">
                                    <DropdownMultiMenu
                                        dropName={t("words.file")}
                                        buttonClassName="px-0 pb-2 rounded-lg transition-colors mapping-topbar-btn"
                                        menuItems={menuItemsFile}
                                        id="dropdownFile"
                                        key={"dropdownFile"}
                                        data-tutorial="flowchart-export-details"
                                    />
                                    {isEditing ?
                                        <DropdownMultiMenu
                                            dropName={t("words.edition")}
                                            buttonClassName="px-0 pb-2 rounded-lg transition-colors mapping-topbar-btn"
                                            menuItems={menuItemsEdit}
                                            id="dropdownEdit"
                                            key={'dropdownEdit'}
                                        />
                                        :
                                        <></>
                                    }
                                    <DropdownMultiMenu
                                        dropName={t("words.view")}
                                        buttonClassName="px-0 pb-2 rounded-lg transition-colors mapping-topbar-btn"
                                        menuItems={menuItemsView}
                                        id="dropdownView"
                                        key={'dropdownView'}
                                        data-tutorial="flowchart-layers"
                                    />
                                    {isEditing ?
                                        <DropdownMultiMenu
                                            dropName={'Format'}
                                            buttonClassName="px-0 pb-2 rounded-lg transition-colors mapping-topbar-btn"
                                            menuItems={menuItemsFormat}
                                            id="menuItemsFormat"
                                            key={'menuItemsFormat'}
                                        />
                                        :
                                        <></>
                                    }
                                    {isProcessMapManager ?
                                        <DropdownMultiMenu
                                            dropName={t('features.swimlane.processOwner')}
                                            buttonClassName="px-0 pb-2 rounded-lg transition-colors mapping-topbar-btn"
                                            menuItems={menuItemsProcessOwner}
                                            id="menuItemsProcessOwner"
                                            key={'menuItemsProcessOwner'}
                                            data-tutorial="flowchart-process-owner"
                                        />
                                        :
                                        <></>
                                    }
                                    <DropdownMultiMenu
                                        dropName={t("words.help")}
                                        buttonClassName="px-0 pb-2 rounded-lg transition-colors mapping-topbar-btn"
                                        menuItems={menuItemsHelp}
                                        id="menuItemsHelp"
                                        key={'menuItemsHelp'}
                                    />


                                    {/* {isEditing &&
                        <button
                            className={`py-2 rounded flex items-center gap-2  ${showProperties === "shape"
                                ? 'text-blue-700'
                                : `text-black`
                                }`}

                            onClick={() => handlesHowProperties("shape")}
                        >
                            {t("features.swimlane.shapes")}
                        </button>
                    } */}


                                    {/* History Controls */}


                                </div>

                                <div className="flex items-center gap-4">
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Temps réel + collaborateurs : toujours sur la 1ère ligne, à gauche d’Analysis (pas sur la barre propriétés) */}
                    <div className="flex flex-nowrap items-center gap-3 flex-shrink-0 pt-1">
                        <ActiveUsersBar
                            activeUsers={activeUsers}
                            currentUserId={currentUserId}
                            saveStatus={saveStatus}
                            isConnected={isWsConnected}
                        />
                        {showWarnings && warningsStakeholderLoading && (
                            <span
                                className="text-xs font-medium text-amber-700 whitespace-nowrap flex-shrink-0 animate-pulse"
                                aria-live="polite"
                            >
                                {t('features.swimlane.warningsLoading')}
                            </span>
                        )}
                        {isExporting && (
                            <span
                                className="inline-flex items-center gap-2 text-xs font-medium text-slate-600 whitespace-nowrap flex-shrink-0"
                                role="status"
                                aria-live="polite"
                                aria-busy="true"
                            >
                                <Loader2 className="h-4 w-4 animate-spin text-blue-600" strokeWidth={2.25} />
                                {t('features.swimlane.exportInProgress')}
                            </span>
                        )}
                        {!showRightPanel && (
                            <button
                                onClick={() => {
                                    void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.panelOpenAnalysis);
                                    setShowRightPanel(true);
                                }}
                                className="relative inline-flex items-center gap-2 py-2 px-4 rounded-full flex-shrink-0"
                                style={{ border: "1px solid var(--tenant-primary, #017d7c)" }}
                                id="analyseButton"
                                data-tutorial="flowchart-analysis"
                            >
                                <Sparkles className="rotate-icon" size={22} style={{ color: "var(--tenant-primary, #017d7c)" }} />
                                <span className="font-medium">{t('features.swimlane.analysis')}</span>
                            </button>
                        )}
                    </div>
                </div>


                {/* Properties Panel */}
                {
                    (isPropertiesPanelOpen && isEditing) && (
                        <div 
                            className="mapping-topbar-props border-t px-4 py-2 flex items-center gap-3 small"
                            data-tutorial="flowchart-properties"
                            style={{
                                borderColor: '#e5e7eb',
                                backgroundColor: '#ffffff',
                                color: '#374151',
                            }}
                        >
                            {isEditing &&
                                <div className="flex items-center gap-3">
                                    <button
                                        onClick={() => {
                                            void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.editUndo);
                                            onUndo();
                                        }}
                                        disabled={!canUndo}
                                        className={`py-2 rounded flex items-center gap-2 ${canUndo
                                            ? 'text-blue-600 hover:bg-blue-100'
                                            : ' text-gray-400 cursor-not-allowed'
                                            }`}
                                        title={t("features.swimlane.undo")}
                                    >
                                        <Undo2 className="w-5 h-5" />
                                    </button>
                                    <button
                                        onClick={() => {
                                            void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.editRedo);
                                            onRedo();
                                        }}
                                        disabled={!canRedo}
                                        className={`py-2 rounded flex items-center gap-2 ${canRedo
                                            ? 'text-blue-600 hover:bg-blue-100'
                                            : ' text-gray-400 cursor-not-allowed'
                                            }`}
                                        title={t("features.swimlane.redo")}
                                    >
                                        <Redo2 className="w-5 h-5" />
                                    </button>

                                </div>
                            }
                            {/* Swimlane Width */}
                            {/* {!selectedBlock &&
                                <div className={` ${showRightPanel && "hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:block"}`}>
                                    <div className="flex items-center gap-2" >
                                        <span className="text-gray-600">
                                            W
                                        </span>
                                        <div className="flex items-center gap-1">
                                            <input
                                                type="number"
                                                className="px-1 py-1 border border-gray-300 rounded text-sm"
                                                value={currentData.width}
                                                onChange={handleWidthChange}
                                                min="800"
                                                step="50"
                                                disabled
                                                style={{ width: 55 }}

                                            />
                                            <span className="text-sm text-gray-500">px</span>
                                        </div>
                                    </div>
                                </div>
                            } */}

                            {/* {selectedBlock && } */}
                            {(
                                <>
                                    {/* Block Properties */}
                                    {
                                        <div className={` ${showRightPanel && "hidden md:hidden lg:hidden xl:block 2xl:block"}`}>
                                            <div className=" flex items-center gap-2 ">
                                                <span className="text-gray-600">
                                                    x
                                                </span>
                                                <div className="flex items-center gap-1">
                                                    <input
                                                        type="number"
                                                        className="px-1 py-1 border border-gray-300 rounded text-sm"
                                                        value={selectedBlock?.width || 120}
                                                        onChange={(e) => handleBlockUpdate({ width: parseInt(e.target.value, 10) })}
                                                        min="50"
                                                        step="10"
                                                        style={{ width: 50 }}
                                                    />
                                                    <span className="text-sm text-gray-500">px</span>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {
                                        <div className={`${showRightPanel && "hidden md:hidden lg:hidden xl:hidden 2xl:block"}`}>
                                            <div className="flex items-center gap-2  ">
                                                <span className="text-gray-600">
                                                    y
                                                </span>
                                                <div className="flex items-center gap-1">
                                                    <input
                                                        type="number"
                                                        className="px-1 py-1 border border-gray-300 rounded text-sm"
                                                        value={selectedBlock?.height || 60}
                                                        onChange={(e) => handleBlockUpdate({ height: parseInt(e.target.value, 10) })}
                                                        min="30"
                                                        step="10"
                                                        style={{ width: 50 }}
                                                    />
                                                    <span className="text-sm text-gray-500">px</span>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className="flex items-center gap-2">
                                        <span className="text-gray-600">
                                            <Palette size={16} />
                                        </span>
                                        <ColorPicker
                                            color={selectedBlock?.fill || getBrandingColor()}
                                            onChange={(color) => handleBlockUpdate({ fill: color })}
                                            label=""
                                        />
                                    </div>

                                    {/* Text Properties */}
                                    <div className="flex items-center gap-2">
                                        <span className="text-gray-600">
                                            <Type size={16} />
                                        </span>
                                        <div className="flex items-center gap-1">
                                            <input
                                                type="number"
                                                className="px-1 py-1 border border-gray-300 rounded text-sm"
                                                value={selectedBlock?.textStyle?.fontSize || 14}
                                                onChange={(e) => handleTextStyleUpdate('fontSize', parseInt(e.target.value, 10))}
                                                min="8"
                                                max="72"
                                                style={{ width: 50 }}
                                            />
                                            <span className="text-sm text-gray-500">px</span>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <span className="text-gray-600">
                                            <Paintbrush size={16} />
                                        </span>
                                        <ColorPicker
                                            color={selectedBlock?.textStyle?.textColor || '#ffffff'}
                                            onChange={(color) => handleTextStyleUpdate('textColor', color)}
                                            label=""
                                        />
                                    </div>

                                    {/* <div className="flex items-center gap-2">
                                    <select
                                        className="px-2 py-1 border border-gray-300 rounded text-sm"
                                        value={selectedBlock?.textStyle?.textAlign || 'center'}
                                        onChange={(e) => handleTextStyleUpdate('textAlign', e.target.value)}
                                    >
                                        <option value="left" className="flex items-center gap-1">
                                            <div className="flex items-center">
                                                {t('words.left')}
                                            </div>
                                        </option>
                                        <option value="center" className="flex items-center gap-1">
                                            <div className="flex items-center">
                                                {t('words.center')}
                                            </div>
                                        </option>
                                        <option value="right" className="flex items-center gap-1">
                                            <div className="flex items-center">
                                                {t('words.right')}
                                            </div>
                                        </option>
                                    </select>
                                </div> */}

                                    {/* <div className="flex items-center gap-2">
                                    <select
                                        className="px-2 py-1 border border-gray-300 rounded text-sm"
                                        value={selectedBlock?.textStyle?.textTransform || 'none'}
                                        onChange={(e) => handleTextStyleUpdate('textTransform', e.target.value)}
                                        style={{ width: 60 }}
                                    >
                                        <option title={t('words.uppercase')} value="uppercase">AA</option>
                                        <option title={t('words.normal')} value="none">Aa</option>
                                        <option title={t('words.capitalize')} value="capitalize">Aa</option>
                                        <option title={t('words.lowercase')} value="lowercase">aa</option>
                                    </select>
                                </div> */}
                                    <div className="flex items-center gap-1">

                                        <button
                                            className={`p-1.5 rounded hover:bg-gray-100 transition-colors ${selectedBlock?.textStyle?.fontWeight === 'bold' ? 'bg-gray-100' : ''
                                                }`}
                                            onClick={() => {
                                                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.formatFontBold);
                                                handleTextStyleUpdate('fontWeight', 'bold');
                                            }}
                                            title={t('words.bold')}
                                        >
                                            <span className="text-gray-600 font-bold text-base">B</span>
                                        </button>

                                        <button
                                            className={`p-1.5 rounded hover:bg-gray-100 transition-colors ${selectedBlock?.textStyle?.fontWeight === 'light' ? 'bg-gray-100' : ''
                                                }`}
                                            onClick={() => {
                                                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.formatFontLight);
                                                handleTextStyleUpdate('fontWeight', 'light');
                                            }}
                                            title={t('words.italic')}
                                        >
                                            {/* <span className="text-gray-600 font-light text-base">I</span> */}
                                            <ItalicIcon className="w-4 h-4" />
                                        </button>
                                        {/* <button
                                        className={`p-1.5 rounded hover:bg-gray-100 transition-colors ${selectedBlock?.textStyle?.fontWeight === 'normal' ? 'bg-gray-100' : ''
                                            }`}
                                        onClick={() => handleTextStyleUpdate('fontWeight', 'normal')}
                                        title={t('words.normal')}
                                    >
                                        <span className="text-gray-600 font-normal text-base">B</span>
                                    </button> */}

                                    </div>

                                    {/* Separator before zoom */}
                                    <div className="self-stretch w-px bg-gray-300 mx-0"></div>

                                    {/* Zoom Controls */}
                                    <div className="flex items-center gap-1" data-tutorial="flowchart-zoom">
                                        <button
                                            onClick={() => {
                                                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.propsBarZoomOut);
                                                handleZoom("out");
                                            }}
                                            className="p-1 rounded hover:bg-gray-100"
                                            disabled={scale <= 0.5}
                                        >
                                            <ZoomOut className="w-4 h-4 text-gray-600" />
                                        </button>
                                        <span className="text-sm text-gray-600 p-0">{Math.round(scale * 100)}%</span>
                                        <button
                                            onClick={() => {
                                                void trackUiButtonEventAsync(UI_BUTTON_EVENTS.mapping.propsBarZoomIn);
                                                handleZoom("in");
                                            }}
                                            className="p-1 rounded hover:bg-gray-100"
                                            disabled={scale >= 2}
                                        >
                                            <ZoomIn className="w-4 h-4 text-gray-600" />
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    )
                }
            </div >
            <span ref={activeSaveModal} data-bs-target={`#checkSave`} data-bs-toggle='modal'></span>
            <span ref={activeSaveModal1} data-bs-target={`#checkSaveifBacktoHome`} data-bs-toggle='modal'></span>

        </>

    );
};

export default TopBar;
